import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { devSearchSchemaFor } from "@/modules/dev/registry/previews";

export const Route = createFileRoute("/dev/booking-end-states")({
  validateSearch: devSearchSchemaFor("booking-end-states"),
  component: lazyRouteComponent(
    () => import("@/modules/coaching/booking/dev/BookingEndStatesPreview"),
    "BookingEndStatesPreview",
  ),
});
